import { render, staticRenderFns } from "./addRTFComm.vue?vue&type=template&id=7d24860e&lang=pug&"
import script from "./addRTFComm.vue?vue&type=script&lang=js&"
export * from "./addRTFComm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports